import { ScrollSensor } from "@components/util/ScrollSensor"
import { useRestorableState } from "eddev/routing"
import { useMemo, useRef, useState } from "react"

type Opts = {
  itemsPerPage: number
  totalItems: number
}

export function useScrollPagination(opts: Opts, deps: any[] = []) {
  const [value, setValue] = useRestorableState("scrollPagination", opts.itemsPerPage)
  const tracker = useRef(value)
  tracker.current = value

  // We use a memo to reset the tracker when the deps change, without triggering a re-render, or rendering with the old value
  useMemo(() => {
    tracker.current = opts.itemsPerPage
  }, deps ?? [])

  const sensor = useMemo(
    () => (
      <ScrollSensor
        onActivate={() => {
          // Update the tracker, and trigger a re-render
          tracker.current = Math.min(tracker.current + opts.itemsPerPage, opts.totalItems)
          setValue(tracker.current)
        }}
      />
    ),
    [opts.itemsPerPage, opts.totalItems],
  )

  const page = tracker.current

  return {
    page,
    sensor,
    hasMore: page < opts.totalItems,
  }
}
